<template>
  <el-container style="height: 100vh" class="main-login">
    <el-header class="header">绑定手机</el-header>
    <el-main class="main">
      <el-form
        label-position="right"
        label-width="80px"
        :model="form"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="form.username"
            clearable
            class="inputWidth"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            show-password
            clearable
            autocomplete="off"
            class="inputWidth"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            clearable
            class="inputWidth"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input
            v-model="form.smsCode"
            clearable
            class="inputWidth"
          ></el-input>
          <el-button @click="getSmsCode" :disabled="disButton"
            >获取验证码</el-button
          >
          <span v-if="disButton">请{{ time }}秒后再试</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>
<script>
import { getSmsCodeBindPhone, bindPhone } from "@/api/login.js";

export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
        phone: "",
        smsCode: "",
      },
      disButton: false,
      time: 120,
      timeInterval: "",
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],

        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
  methods: {
    getSmsCode() {
      let params = {
        phone: this.form.phone,
      };
      getSmsCodeBindPhone(params).then((res) => {
        this.disButton = true;
        this.timeInterval = setInterval(() => {
          this.time--;
          console.log(this.time);
          if (this.time == 0) {
            this.disButton = false;
            clearInterval(this.timeInterval);
          }
        }, 1000);
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          bindPhone(this.form)
            .then((res) => {
              this.$alert("绑定手机号成功请重新登录", "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$router.replace("/", () => {
                    location.reload();
                  });
                },
              });
            })
            .catch((res) => {
              console.log(res);
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style>
.main-login {
  background-color: #f6f8fb;
}
.header {
  background-color: #fff;
  padding: 0 34px;
  font-size: 25px;
  color: #007fe1;
  line-height: 60px;
}
.main {
  margin: 20px auto;
  width: 50vw;
}
.el-input.inputWidth {
  width: 250px;
}
.el-button.buttonStyle {
  margin-left: 20px;
}
.el-form-item__content.itemForm {
  margin-top: 20px;
}
</style>
